import { createServerTokenAuthentication } from 'alova/client'
import { createAlova } from 'alova'
import adapterFetch from 'alova/fetch'
import ReactHook from 'alova/react'
import useUserStore from 'store/userStore'
import type { ResponseModel } from 'api/base-model'

const { onAuthRequired, onResponseRefreshToken } =
  createServerTokenAuthentication({
    async login(response) {
      const res: ResponseModel = await response.clone().json()
      useUserStore.setState({ loginInfo: res.data })
    },
    assignToken(method) {
      const { loginInfo } = useUserStore.getState()
      Object.assign(method.config, {
        headers: {
          authorization: `Bearer ${loginInfo?.token}`
        }
      })
    }
  })

const alovaInstance = createAlova({
  baseURL: import.meta.env.VITE_BASE_URL,
  requestAdapter: adapterFetch(),
  cacheFor: null,
  statesHook: ReactHook,
  beforeRequest: onAuthRequired(),
  responded: onResponseRefreshToken({
    async onSuccess(response) {
      const result = await response.json()
      if(result instanceof Object)
      {
        if (result.hasOwnProperty("code"))
        {
          if (result.code === 0) {
            return result
          } else if ([10506, 107, 106].includes(result.code)) {
            location.replace('/login')
            return
          } else {
            return result
          }
        }
        else
        {
          return result
        }
      }
    },
    onError(error) {
      message.error('网络连接异常', 10)
      return Promise.reject(error)
    }
  })
})
const download = createAlova({
  ...alovaInstance.options,
  responded: onResponseRefreshToken({
    async onSuccess(response) {
      const { headers } = response
      const contentType = headers.get('content-type')
      if (contentType === 'application/json') {
        const json = await response.json()
        message.error(json['msg'], 10)
        return Promise.reject(json)
      }
      return response
    }
  })
})

export default alovaInstance

export { download }
